import { useEffect, useState, useCallback, useRef } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Poll the unread message count for the current user.
 * Returns { count, refresh } — `refresh` triggers an immediate re-fetch
 * (call it after opening a thread or sending a message).
 */
export function useUnreadMessages(intervalMs = 30000) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const timer = useRef(null);

  const refresh = useCallback(() => {
    if (!user) { setCount(0); return; }
    api.get("/messages/unread-count")
      .then((r) => setCount(r.data?.count || 0))
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    refresh();
    if (!user) return;
    timer.current = setInterval(refresh, intervalMs);
    return () => clearInterval(timer.current);
  }, [user, intervalMs, refresh]);

  return { count, refresh };
}
